/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pll_In_Reason_AdjustmentInputs */

const vi_pll_in_reason_adjustment = /** @type {(inputs: Pll_In_Reason_AdjustmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh`)
};

/**

* @param {Pll_In_Reason_AdjustmentInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pll_in_reason_adjustment = /** @type {((inputs?: Pll_In_Reason_AdjustmentInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pll_In_Reason_AdjustmentInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pll_in_reason_adjustment(inputs)
});